import PageContainer from "../../components/PageContainer";

const TasksPage = () => {
  return <PageContainer header={"Tasks"}></PageContainer>;
};

export default TasksPage;
